import { render, staticRenderFns } from "./JournalInput.vue?vue&type=template&id=35fbae52&scoped=true"
import script from "./JournalInput.vue?vue&type=script&lang=js"
export * from "./JournalInput.vue?vue&type=script&lang=js"
import style0 from "./JournalInput.vue?vue&type=style&index=0&id=35fbae52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbae52",
  null
  
)

export default component.exports